/*
    Mutation naming convention.

    UPDATE_ - Update the complete module store.
    SET_ - Update a single property in the module store.
    RESET_ - Clear the module store back to its original values.

    NOTE: We could of reused mutation names across all modules
    e.g. RESET, UPDATE, ADD to avoid types like SESSION_RESET_SESSION,
    but I think in the long run it is better to explicity state each mutation than be generic.
*/
export const SET_TOGGLE = 'setToggle';
export const SET_PAGE_VIEW_TYPE = 'setPageViewType';
export const SET_APP_THEME = 'setAppTheme';
export const SET_HELIX_ACTIVE_PANELS = 'setHelixActivePanels';
export const SET_TOGGLE_APP_USAGE = 'setToggleAppUsage';
export const SET_SHOW_HEADER_CONTAINER = 'setShowHeaderContainer';
export const SET_AXIOS = 'setAxios';
export const SET_EXCURSION_TYPES = 'setExcursionTypes';
export const SET_RISK_CATEGORIES = 'setRiskCategories';
export const SET_EXCURSION_ID = 'setExcursionId';
export const RESET_EXCURSION = 'resetExcursion';
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const SET_CONFIG = 'setConfig';
export const INIT_CLIENT = 'initClient';
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const ENGINEERING_SET_TOGGLE = `engineering/${SET_TOGGLE}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const VIEW_TYPE_SET_PAGE_VIEW_TYPE = `view-type/${SET_PAGE_VIEW_TYPE}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const COMPLIANCE_GRAPHQL_MEDIATOR_SET_CONFIG = `compliance-graphql-mediator/${SET_CONFIG}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const THEME_SET_APP_THEME = `theme/${SET_APP_THEME}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const HELIX_COMPONENTS_SET_HELIX_ACTIVE_PANELS = `helix-components/${SET_HELIX_ACTIVE_PANELS}`;
export const HELIX_COMPONENTS_SET_TOGGLE_APP_USAGE = `helix-components/${SET_TOGGLE_APP_USAGE}`;
export const HELIX_COMPONENTS_SET_SHOW_HEADER_CONTAINER = `helix-components/${SET_SHOW_HEADER_CONTAINER}`;
// -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
export const STB_EXCURSION_SET_AXIOS = `stb-excursions/${SET_AXIOS}`;
export const STB_EXURCION_SET_EXCURSION_TYPES = `stb-excursions/${SET_EXCURSION_TYPES}`;
export const STB_EXCURSION_SET_RISK_CATEGORIES = `stb-excursions/${SET_RISK_CATEGORIES}`;
export const STB_EXCURSION_SET_EXCURSION_ID = `stb-excursions/${SET_EXCURSION_ID}`;
export const STB_EXCURSION_RESET_EXCURSION = `stb-excursions/${RESET_EXCURSION}`;
